<template>
  <button
    type="button"
    class="group px-4 py-2 focus:outline-none w-full text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
    role="menuitem"
    @click="execute"
  >
    <p>Send Order to {{ serviceName }}</p>
  </button>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
    serviceName: {
      type: String,
      default: 'SoftOne',
    },
  },
  methods: {
    async execute() {
      this.$modal.show({
        component: 'SoftOneDocumentCreateModal',
        props: {
          orderId: this.order.id,
          thirdPartyServiceId: this.thirdPartyServiceId,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
  },
};
</script>
